import styled from 'styled-components'
import colors from '../../theme/colors'
import fonts from '../../theme/fonts'

export const DropDownMenuStyles = styled.div<{ backgroundColor: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 24px;
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : colors.Primary.White)};
  font-family: ${fonts.fontFamilies.Inter};
  font-style: normal;
  font-weight: normal;
  font-size: ${fonts.fontSizes.p16};
  user-select: none;
  position: relative;
  width: 232px;
  height: 48px;
  padding: 0 16px;

  &:hover {
    cursor: pointer;
  }

  .select__header {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .select__header-text,
    .select__header-arrow
    {
      margin: 0;
      line-height: 9px;
      min-height: 48px;
      display: inline-flex;
      align-items: center;
    }
  }

  .select__content {
    width: inherit;
    background: #FFFFFF;
    box-shadow: 1px 1px 7px 2px rgb(209 209 209 / 25%);
    border-radius: 8px;
    overflow: hidden;
    display: none;

    &.select__content--expanded {
      display: table;
      position: absolute;
      top: 49px;
      z-index: 1;
    }

    a {
      display: list-item;
      padding: 0 16px 0 0;
      height: 48px;
      line-height: 48px;
      text-decoration: none;
      white-space: nowrap;

      svg {
        margin: 0 16px;
      }

      &:hover {
        background: ${colors.Primary.GreyLight};
      }
    }

    button {
      width: 100%;
      text-decoration: none;
      text-decoration: none;
      display: flex;
      padding: 16px 0;
      outline: none;

      svg {
        margin: 0 16px;
      }

      &:hover {
        background: ${colors.Primary.GreyLight};
      }
    }

    .select__title {
      font-size: 1.2rem;
      font-weight: ${fonts.fontWeights.medium};
      color: ${colors.Primary.yellow500};
    }
  }
`

export default DropDownMenuStyles
